
import { Component, Vue } from 'vue-property-decorator'

/**
 * ulタグの基底コンポーネント
 */
@Component
export default class UnorderedListBase extends Vue {}
